import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';
import { ApiResponse } from './types/common';

export type Banner = {
  active: boolean;
  label: string;
  title: string;
  description: string;
  cta: string;
  ctaUrl: string;
  sortOrder: number;
};

const bannerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query<ApiResponse<Banner[]>, void>({
      query: () => apiRoutes.banners,
    }),
  }),
});

export const { useLazyGetBannersQuery } = bannerApi;
